import {cardsDataInterface, DashboardWrapperTypes} from '../../@types'
import {PATH_CALL_TRACKING, PATH_CONVERSION_CLICK, PATH_NATURAL_REFERENCING, PATH_WEB_FORMS} from '../../routing/paths'
import {ProductModel} from '../../modules/auth/models/UserModel'

const getCardsData = (
    data: DashboardWrapperTypes | undefined,
    webForms: ProductModel,
    callTracking: ProductModel,
): cardsDataInterface[] => {
    return [
        {
            enabled: true,
            iconPath: '/media/icons/duotune/general/gen060.svg',
            body: {total: data?.dashboardCards.visits || 0, text: 'visites', description: ''},
            to: PATH_NATURAL_REFERENCING.root,
        },
        {
            enabled: true,
            iconPath: '/media/icons/duotune/arrows/arr029.svg',
            body: {total: data?.dashboardCards.conversions || 0, text: 'conversions', description: ''},
            to: '',
        },
        {
            enabled: !!webForms.activated_at,
            iconPath: '/media/icons/duotune/general/gen005.svg',
            body: {total: data?.dashboardCards.forms || 0, text: 'formulaires', description: ''},
            to: PATH_WEB_FORMS.root,
        },
        {
            enabled: !!callTracking.activated_at,
            iconPath: '/media/icons/duotune/communication/com014.svg',
            body: {total: data?.dashboardCards.calls || 0, text: 'appels', description: ''},
            to: PATH_CALL_TRACKING.root,
        },
        {
            enabled: true,
            iconPath: '/media/icons/duotune/coding/cod006.svg',
            body: {
                total: data?.dashboardCards.numberOofClicksOnPhone || 0,
                text: 'nombre de clics sur le téléphone',
                description: '',
            },
            to: PATH_CONVERSION_CLICK.root,
        },
    ]
}

export {
    getCardsData,
}